export var Global = 
{
	// THIS LINE TO START IN LOCAL
	//url: 'http://localhost:3700/api/'
	// THIS LINE TO START IN SERVER
	url: '/api/'
};